import { render, staticRenderFns } from "./EditSmtpSetting.vue?vue&type=template&id=db90bcda"
import script from "./EditSmtpSetting.vue?vue&type=script&lang=js"
export * from "./EditSmtpSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports